import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';

// Contextual internal links from high-authority live pages down to the
// newer guide/data pages, to pass authority and aid crawl/discovery.
// Rendered as a white card so it's readable on any page background.
// `links` is an array of { href, labelKey } where labelKey is a common-namespace key.
export default function RelatedLinks({ links, headingKey = 'related_guides' }) {
    const { t } = useTranslation('common');
    if (!links || links.length === 0) return null;

    return (
        <nav
            aria-label={t(headingKey)}
            className="mt-10 mx-auto max-w-md bg-white rounded-lg p-5 text-left text-gray-800 shadow-sm"
        >
            <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
                {t(headingKey)}
            </h2>
            <ul className="divide-y divide-gray-100">
                {links.map(({ href, labelKey }) => (
                    <li key={href}>
                        <Link
                            href={href}
                            className="group flex items-center justify-between gap-3 py-3 text-[var(--secondary)] hover:text-[var(--primary)]"
                        >
                            <span className="underline decoration-[var(--secondary)] underline-offset-2 group-hover:decoration-[var(--primary)]">
                                {t(labelKey)}
                            </span>
                            <span
                                aria-hidden="true"
                                className="text-gray-300 transition group-hover:translate-x-0.5 group-hover:text-[var(--secondary)]"
                            >
                                →
                            </span>
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
